import { ComponentProps } from 'react';
import { AnalyticsInfo } from '@gv/triage-components';

import * as Styles from './styles';

export const AnalyticsCard = (props: ComponentProps<typeof AnalyticsInfo>) => {
  return <Styles.Card transparent {...props} />;
};
